var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "wa-page",
    {
      attrs: {
        "view-slug": "icon-landing",
        "is-showing-v7-prerelease-notice": true,
      },
    },
    [
      _c("wa-page-header", { attrs: { slot: "header" }, slot: "header" }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "app-content",
          attrs: { slot: "content", role: "main" },
          slot: "content",
        },
        [
          _vm.isLoading
            ? _c("wa-icons-loading")
            : _c(
                "ais-instant-search",
                {
                  attrs: {
                    "search-client": _vm.searchClient,
                    "index-name": _vm.index,
                  },
                },
                [
                  _c("ais-configure", {
                    attrs: { distinct: true, facetFilters: _vm.facetFilters() },
                  }),
                  _vm._v(" "),
                  _vm.iconId != null
                    ? _c("ais-hits", {
                        staticClass: "app-content",
                        attrs: {
                          "transform-items": _vm.transformItems,
                          role: "main",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ items }) {
                                return items.length > 0
                                  ? _c("div", {}, [
                                      _c(
                                        "div",
                                        { attrs: { id: "icon-landing" } },
                                        [
                                          _c(
                                            "main",
                                            {
                                              staticClass: "padding-y-5xl",
                                              staticStyle: {
                                                background: "var(--white)",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "container" },
                                                [
                                                  _vm.display == "detail"
                                                    ? [
                                                        _vm.isOlderVersion
                                                          ? _c(
                                                              "wa-old-version-alert",
                                                              {
                                                                attrs: {
                                                                  subject:
                                                                    _vm.icon
                                                                      .name,
                                                                  "is-individual-icon":
                                                                    "",
                                                                },
                                                              }
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "row roomy laptop:align-stretch laptop:align-between margin-bottom-lg",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "column-12 laptop:column-6",
                                                              },
                                                              [
                                                                _c(
                                                                  "icon-name-and-link",
                                                                  {
                                                                    attrs: {
                                                                      icon: _vm.icon,
                                                                      "is-pro-user":
                                                                        _vm.isProUser,
                                                                      "is-pro-icon":
                                                                        _vm.isProIcon,
                                                                      "is-using-modal": false,
                                                                      styling:
                                                                        _vm.styling,
                                                                    },
                                                                    on: {
                                                                      openProIconModal:
                                                                        _vm.openProIconModal,
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "column-12 laptop:column-6 display-flex flex-row flex-nowrap flex-items-center laptop:flex-content-end",
                                                                staticStyle: {
                                                                  gap: "var(--spacing-md)",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "icon-unicodes",
                                                                  {
                                                                    attrs: {
                                                                      icon: _vm.icon,
                                                                      "is-duotone":
                                                                        _vm.isDuotoneIcon,
                                                                      "is-using-modal": false,
                                                                      styling:
                                                                        _vm.styling,
                                                                    },
                                                                  }
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "icon-glyphs",
                                                                  {
                                                                    attrs: {
                                                                      icon: _vm.icon,
                                                                      "is-duotone":
                                                                        _vm.isDuotoneIcon,
                                                                      "is-using-modal": false,
                                                                      styling:
                                                                        _vm.styling,
                                                                    },
                                                                  }
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "icon-svg-download",
                                                                  {
                                                                    attrs: {
                                                                      "can-download-icon":
                                                                        _vm.canDownloadIcon,
                                                                      icon: _vm.icon,
                                                                      "is-pro-icon":
                                                                        _vm.isProIcon,
                                                                      "is-pro-user":
                                                                        _vm.isProUser,
                                                                      "is-custom-icon": false,
                                                                      "is-using-modal": false,
                                                                      styling:
                                                                        _vm.styling,
                                                                    },
                                                                    on: {
                                                                      openProIconModal:
                                                                        _vm.openProIconModal,
                                                                      getSelectedAction:
                                                                        _vm.getSelectedAction,
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _vm.$marketing
                                                          .showAdvertising
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "row roomy align-stretch margin-bottom-2xl",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "column-12 laptop:column",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "wa-carbon-ad"
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "wrap-icon-details row roomy align-stretch laptop:margin-bottom-2xl",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "icon-detail-grid-preview column-12 margin-bottom-2xl laptop:margin-bottom-0 laptop:column-6",
                                                              },
                                                              [
                                                                _c(
                                                                  "icon-preview",
                                                                  {
                                                                    attrs: {
                                                                      "preview-mode":
                                                                        _vm.previewMode,
                                                                      styling:
                                                                        _vm.styling,
                                                                      icon: _vm.icon,
                                                                      "default-styles":
                                                                        _vm.defaultStyles,
                                                                      "display-icon-preview-controls": true,
                                                                      version:
                                                                        _vm.version,
                                                                      "is-duotone":
                                                                        _vm.isDuotoneIcon,
                                                                    },
                                                                    on: {
                                                                      resetStyles:
                                                                        _vm.resetStyles,
                                                                      changePreviewMode:
                                                                        _vm.changePreviewMode,
                                                                      toggleStyleOptions:
                                                                        _vm.toggleStyleOptions,
                                                                      toggleAnimationOptions:
                                                                        _vm.toggleAnimationOptions,
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "icon-detail-use column-12 laptop:column-6 margin-bottom-2xl laptop:margin-bottom-0",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "margin-bottom-2xl",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "icon-pack-selector",
                                                                      {
                                                                        attrs: {
                                                                          icon: _vm.icon,
                                                                          styling:
                                                                            _vm.styling,
                                                                          version:
                                                                            _vm.version,
                                                                          "default-styles":
                                                                            _vm.defaultStyles,
                                                                        },
                                                                        on: {
                                                                          change:
                                                                            (
                                                                              newStyling
                                                                            ) =>
                                                                              (_vm.styling =
                                                                                newStyling),
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "icon-code-snippet",
                                                                  {
                                                                    attrs: {
                                                                      id: _vm
                                                                        .icon
                                                                        .name,
                                                                      "can-download-icon":
                                                                        _vm.canDownloadIcon,
                                                                      "default-styles":
                                                                        _vm.defaultStyles,
                                                                      icon: _vm.icon,
                                                                      "icon-abstract":
                                                                        _vm.iconAbstract,
                                                                      "is-duotone":
                                                                        _vm.isDuotoneIcon,
                                                                      "is-pro-icon":
                                                                        _vm.isProIcon,
                                                                      "is-pro-user":
                                                                        _vm.isProUser,
                                                                      "is-using-modal": false,
                                                                      showing:
                                                                        _vm.showing,
                                                                      styling:
                                                                        _vm.styling,
                                                                      viggo:
                                                                        _vm.viggo,
                                                                    },
                                                                    on: {
                                                                      show: _vm.changeShowing,
                                                                      openProIconModal:
                                                                        _vm.openProIconModal,
                                                                      getSelectedAction:
                                                                        _vm.getSelectedAction,
                                                                    },
                                                                  }
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "icon-actions",
                                                                  {
                                                                    attrs: {
                                                                      "can-access-icon":
                                                                        _vm.canAccessIcon,
                                                                      "can-use-icon":
                                                                        _vm.canUseIcon,
                                                                      icon: _vm.icon,
                                                                      "is-custom-icon": false,
                                                                      "is-pro-icon":
                                                                        _vm.isProIcon,
                                                                      "is-pro-plus-icon":
                                                                        _vm.isProPlusIcon(
                                                                          _vm.icon
                                                                        ),
                                                                      "is-pro-user":
                                                                        _vm.isProUser,
                                                                      "is-using-modal": false,
                                                                      styling:
                                                                        _vm.styling,
                                                                    },
                                                                    on: {
                                                                      editIcon:
                                                                        _vm.editIcon,
                                                                      getSelectedAction:
                                                                        _vm.getSelectedAction,
                                                                      openProIconModal:
                                                                        _vm.openProIconModal,
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "icon-detail-styling-tabs column-12",
                                                              },
                                                              [
                                                                _c(
                                                                  "icon-styling",
                                                                  {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "show",
                                                                          rawName:
                                                                            "v-show",
                                                                          value:
                                                                            _vm.isShowingStyleOptions,
                                                                          expression:
                                                                            "isShowingStyleOptions",
                                                                        },
                                                                      ],
                                                                    attrs: {
                                                                      icon: _vm.icon,
                                                                      styling:
                                                                        _vm.styling,
                                                                      version:
                                                                        _vm.version,
                                                                      "default-styles":
                                                                        _vm.defaultStyles,
                                                                    },
                                                                    on: {
                                                                      change: (
                                                                        newStyling
                                                                      ) =>
                                                                        (_vm.styling =
                                                                          newStyling),
                                                                    },
                                                                  }
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "icon-animations",
                                                                  {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "show",
                                                                          rawName:
                                                                            "v-show",
                                                                          value:
                                                                            _vm.isShowingAnimationOptions,
                                                                          expression:
                                                                            "isShowingAnimationOptions",
                                                                        },
                                                                      ],
                                                                    attrs: {
                                                                      icon: _vm.icon,
                                                                      styling:
                                                                        _vm.styling,
                                                                      version:
                                                                        _vm.version,
                                                                    },
                                                                    on: {
                                                                      change: (
                                                                        newStyling
                                                                      ) =>
                                                                        (_vm.styling =
                                                                          newStyling),
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _vm.isBrandsIcon
                                                          ? _c(
                                                              "icon-brand-notice"
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.isSponsored
                                                          ? _c(
                                                              "icon-sponsorship",
                                                              {
                                                                attrs: {
                                                                  "sponsor-name":
                                                                    _vm.icon
                                                                      .sponsored
                                                                      .label,
                                                                  "sponsor-url":
                                                                    _vm.icon
                                                                      .sponsored
                                                                      .url,
                                                                },
                                                              }
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "row roomy align-middle align-center",
                                                            staticStyle: {
                                                              gap: "var(--spacing-md)",
                                                            },
                                                          },
                                                          [
                                                            _vm.hasCategories
                                                              ? _c(
                                                                  "icon-categories",
                                                                  {
                                                                    attrs: {
                                                                      categories:
                                                                        _vm.icon
                                                                          .categories,
                                                                      icon: _vm.icon,
                                                                      "is-using-modal": true,
                                                                    },
                                                                  }
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _vm.hasAliases
                                                              ? _c(
                                                                  "icon-aliases",
                                                                  {
                                                                    attrs: {
                                                                      aliases:
                                                                        _vm.icon
                                                                          .aliases
                                                                          .names,
                                                                    },
                                                                  }
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _c(
                                                              "icon-version-info",
                                                              {
                                                                attrs: {
                                                                  icon: _vm.icon,
                                                                },
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.display == "edit"
                                                    ? _c(
                                                        "div",
                                                        [
                                                          _c("icon-customize", {
                                                            attrs: {
                                                              "default-styles":
                                                                _vm.defaultStyles,
                                                              icon: _vm.icon,
                                                              "is-pro-user":
                                                                _vm.isProUser,
                                                              "is-using-modal": false,
                                                              "selected-family":
                                                                _vm.styling
                                                                  .family,
                                                              "selected-style":
                                                                _vm.styling
                                                                  .style,
                                                              styling:
                                                                _vm.styling,
                                                              version:
                                                                _vm.version,
                                                            },
                                                            on: {
                                                              closeEditor:
                                                                _vm.closeEditor,
                                                              change: (
                                                                newStyling
                                                              ) =>
                                                                (_vm.styling =
                                                                  newStyling),
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ],
                                                2
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "aside",
                                            {
                                              staticClass:
                                                "container padding-top-5xl padding-bottom-7xl",
                                            },
                                            [
                                              _c("icon-examples", {
                                                attrs: {
                                                  icon: _vm.icon,
                                                  "selected-family":
                                                    _vm.styling.family,
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("more-icons-like", {
                                                attrs: {
                                                  icon: _vm.icon,
                                                  "results-view":
                                                    _vm.resultsView,
                                                  "selected-style":
                                                    _vm.styling.style,
                                                  "selected-family":
                                                    _vm.styling.family,
                                                  "search-query": _vm.icon.name,
                                                  version: _vm.version,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("wa-modal-upsell", {
                                            attrs: {
                                              icon: _vm.icon,
                                              "is-showing":
                                                _vm.isShowingUpsellModal,
                                              "upsell-requirement":
                                                _vm.upsellRequirement,
                                              "upsell-trigger":
                                                _vm.getSelectedAction(
                                                  _vm.selectedAction
                                                ),
                                              "upsell-trigger-icon-name":
                                                _vm.selectedActionIcon,
                                            },
                                            on: {
                                              "close-modal":
                                                _vm.closeProIconModal,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ])
                                  : _c("icon-does-not-exist", {
                                      staticClass: "app-content",
                                      attrs: {
                                        slot: "content",
                                        "icon-name": _vm.iconId,
                                        "selected-style": _vm.styling.style,
                                        "selected-family": _vm.styling.family,
                                        version: _vm.version,
                                      },
                                      slot: "content",
                                    })
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      })
                    : _vm._e(),
                ],
                1
              ),
        ],
        1
      ),
      _vm._v(" "),
      _c("wa-page-footer", { attrs: { slot: "footer" }, slot: "footer" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }